<template>
  <v-dialog v-model="dialog" scrollable :retain-focus="false" max-width="900px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        color="primary"
        small
        :ripple="false"
        class="link non-text-transformation display-btn"
        v-bind="attrs"
        v-on="on"
        data-cy="modal-non-editable-btn"
      >
        {{ $t(modalInformation.activator) }}
      </v-btn>
    </template>
    <v-card data-cy="modal-non-editable-card">
      <div class="px-10 pt-6">
        <v-card-title class="text-h3 px-0 dialog-title">
          {{ $t(modalInformation.title) }}
        </v-card-title>
        <form @submit.prevent>
          <v-text-field outlined clearable prepend-inner-icon="mdi-magnify" v-model="filterText" />
        </form>
      </div>
      <v-card-text class="modal__container">
        <div>
          <v-list>
            <v-list-item
              v-for="(element, i) in filteredServices"
              :key="'list' + i"
              :class="i < filteredServices.length - 1 ? 'modal-elements' : null"
            >
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <div class="d-flex flex-column">
                    <p class="mb-2 text-body-2">{{ $t(element.desc_key) }}</p>
                  </div>
                  <div class="d-flex modal-elements__price">
                    <div v-if="element.type === 'LIST-VALUES'" class="d-flex flex-column mx-8">
                      <p class="mb-1 text-body-2">
                        {{ $t('ADDITIONAL_SERV_FIELD_SELECT') }}
                      </p>
                      <p class="mb-2 text-body-2">
                        {{ $t(getListElementSelected(element.listValues, element.selected)) }}
                      </p>
                    </div>
                    <div v-else class="d-flex flex-column mx-8">
                      <p class="mb-2">{{ $t('ADDITIONAL_SERV_FIELD_PRICE') }}</p>
                      <p class="mb-2 text-body-2">
                        {{ formatValue(element.value) }}
                        <span>{{ suffix(element.type) }}</span>
                      </p>
                    </div>
                    <template v-if="element.type === 'PERCENTAGE'">
                      <div class="d-flex flex-column mx-8">
                        <template v-if="element.minValue > 0">
                          <p class="mb-2">{{ $t('ADDITIONAL_SERV_FIELD_MIN') }}</p>
                          <p class="mb-2 text-body-2">
                            {{ formatValue(element.minValue) }}
                            <span v-if="!isValueEmpty(element.minValue)">&#8364;</span>
                          </p>
                        </template>
                      </div>
                      <div class="d-flex flex-column mx-8">
                        <template v-if="element.maxValue > 0">
                          <p class="mb-2">
                            {{ $t('ADDITIONAL_SERV_FIELD_MAX') }}
                          </p>
                          <p class="mb-2 text-body-2">
                            {{ formatValue(element.maxValue) }}
                            <span v-if="!isValueEmpty(element.maxValue)">&#8364;</span>
                          </p>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end pa-4">
        <div>
          <v-btn
            v-for="(button, indexButtons) in modalInformation.buttons"
            :key="indexButtons"
            :class="`ml-4 link non-text-transformation ${button.class ? button.class : null}`"
            :color="buttonColor(button.action)"
            tile
            :outlined="buttonOutlined(button.action)"
            @click="button.action"
          >
            {{ $t(button.label) }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { numberOperations, normalizeAccents } from '@/helpers/helpers'
export default {
  name: 'NonEditableServicesDialog',
  data() {
    return {
      dialog: false,
      modalInformation: {
        activator: 'ADDITIONAL_SERV_VIEW_MORE',
        title: 'ADDITIONAL_SERV_MODAL_TITLE',
        type: 'list',
        icon: 'mdi mdi-pencil theme--light',
        activeIconId: '',
        buttons: [
          {
            label: 'ADDITIONAL_SERV_MODAL_ACTIONS_CLOSE',
            action: this.close,
          },
        ],
      },
      filterText: '',
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    additionalServices() {
      return this[GET_OFFER_ITEM]('extraServicesList')
    },
    nonEditableServices() {
      return this.additionalServices?.filter(this.isNonEditable) ?? []
    },
    filteredServices() {
      if (!this.filterText) return this.nonEditableServices
      return this.nonEditableServices.filter(serv =>
        normalizeAccents(this.$t(serv.desc_key)).includes(normalizeAccents(this.filterText)),
      )
    },
  },
  methods: {
    isNonEditable(element) {
      return !element.isEditable && element.isVisible
    },
    close() {
      this.dialog = false
    },
    suffix(type) {
      if (type === 'PERCENTAGE') {
        return '%'
      }

      if (type === 'AMOUNT') {
        return '€'
      }

      return ''
    },
    formatValue(num) {
      return num === null || num === ''
        ? '-'
        : numberOperations
            .roundNumber(num, 2)
            .toFixed(2)
            .replace('.', ',')
    },
    getListElementSelected(list, selected) {
      return list.filter(code => code.value === selected)[0].desc_key
    },
    buttonColor(action) {
      return action === 'close' && this.modalInformation.buttons.length > 1 ? 'black' : 'primary'
    },
    buttonOutlined(action) {
      return action === 'close' && this.modalInformation.buttons.length > 1
    },
    isValueEmpty(value) {
      return value === null || value === ''
    },
  },
}
</script>

<style scoped lang="scss">
.modal {
  &__container {
    height: rem(400);
  }
  &-elements {
    border-bottom: 0.5px solid $grey-mid;

    &__price {
      width: 50%;
    }
  }
}
</style>
